// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bdFPo","colBig":"styles_colBig__2lgaV","colSmall":"styles_colSmall__Xq5BC"};